import { BillingVoucherStatus } from '@debbie/common/dist/insights/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import BillingAppendixSetupSelect from '../../BillingAppendixSetupSelect.js';
import BillingModelSelect from '../../BillingModelSelect.js';
import Button from '../../Button.js';
import ButtonGroup from '../../ButtonGroup.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const BillingGroup = ({ caseFilter }) => {
    const lang = useSelector((s) => s.lang);
    const text = lang.caseFilter.economyFilter;
    const billingOptions = [
        { value: undefined, label: text.allCases, description: text.allCasesHint },
        {
            value: BillingVoucherStatus.Pending,
            label: text.pending,
            description: text.pendingHint,
        },
        {
            value: BillingVoucherStatus.Billed,
            label: text.billed,
            description: text.billedHint,
        },
        {
            value: BillingVoucherStatus.Both,
            label: text.both,
            description: text.bothHint,
        },
    ];
    return (React.createElement(FilterGroup, { name: text.billing },
        React.createElement(FilterOption, { active: caseFilter.billingVoucherStatus != null, header: text.billingStatus, subheader: text.billingHint, onDeactivate: () => caseFilterStore.clearFilter('billingVoucherStatus') },
            React.createElement("div", { role: "group", "aria-label": text.billing },
                React.createElement(StatusOptions, null, billingOptions.map((option) => (React.createElement(Button, { key: option.value ?? 'all', type: "button", size: "mini", theme: caseFilter.billingVoucherStatus === option.value
                        ? undefined
                        : 'secondary', pressed: caseFilter.billingVoucherStatus === option.value, onClick: () => caseFilterStore.updateFilter({
                        billingVoucherStatus: option.value,
                    }) }, option.label))))),
            React.createElement(Hint, null, billingOptions.find((option) => option.value === caseFilter.billingVoucherStatus)?.description),
            React.createElement(Hint, null, text.overlapHint)),
        React.createElement(FilterOption, { active: (caseFilter.billingModelIds?.length ?? 0) > 0, header: lang.caseFilter.economyBillingModels, onDeactivate: () => caseFilterStore.clearFilter('billingModelIds') },
            React.createElement(BillingModelSelect, { multi: true, value: caseFilter.billingModelIds ?? [], onChange: (ids) => caseFilterStore.updateFilter({
                    billingModelIds: ids.length > 0 ? ids : undefined,
                }) })),
        React.createElement(FilterOption, { active: (caseFilter.billingAppendixSetupIds?.length ?? 0) > 0, header: lang.caseFilter.economyBillingAppendixSetups, onDeactivate: () => caseFilterStore.clearFilter('billingAppendixSetupIds') },
            React.createElement(BillingAppendixSetupSelect, { multi: true, value: caseFilter.billingAppendixSetupIds ?? [], onChange: (ids) => caseFilterStore.updateFilter({
                    billingAppendixSetupIds: ids.length > 0 ? ids : undefined,
                }) }))));
};
export default BillingGroup;
const Hint = styled.p `
  margin: 5px 0;
  font-size: 0.9em;
  line-height: 1.5;
  color: #666;
`;
const StatusOptions = styled(ButtonGroup) `
  margin: 10px 0 5px;
  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
//# sourceMappingURL=BillingGroup.js.map